<template>
  <div>
    <div class="tit" :class="curLang == 'rus' ? 'fnt_24' : 'fnt_32'">{{ globalDataArray.siteTemplateLanguage.person_user_center }}</div>
    <div class="personMenu" :class="curLang == 'rus' ? 'fnt_16' : 'fnt_20'" ref="personMenu">
      <div class="item" v-for="(item,index) in menu" :key="'menu' + index" @click="gopage(item.path)" :class="item.path == isSelect ? 'cur' : ''">
        <img :src="item.icon">{{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'Personmenu',
  data() {
    return {
      menu: [{
        id: '0',
        name: this.globalDataArray.siteTemplateLanguage.personal_information,
        icon: `${require('@/assets/images/person0.png')}`,
        path: '/mypersonal'
      },
      {
        id: '1',
        name: this.globalDataArray.siteTemplateLanguage.person_signup_record,
        icon: `${require('@/assets/images/person1.png')}`,
        path: '/myrecord'
      },
      {
        id: '2',
        name: this.globalDataArray.siteTemplateLanguage.person_review_record,
        icon: `${require('@/assets/images/person2.png')}`,
        path: '/myexamine'
      },
      {
        id: '3',
        name: this.globalDataArray.siteTemplateLanguage.person_apply_record,
        icon: `${require('@/assets/images/person3.png')}`,
        path: '/myapply'
      },
      {
        id: '4',
        name: this.globalDataArray.siteTemplateLanguage.person_message_record,
        icon: `${require('@/assets/images/person4.png')}`,
        path: '/mymessage'
      },
      {
        id: '7',
        name: this.globalDataArray.siteTemplateLanguage.person_my_invitation || '我的邀请',
        icon: `${require('@/assets/images/person9.png')}`,
        path: '/myinvitation'
      },
      {
        id: '5',
        name: this.globalDataArray.siteTemplateLanguage.person_collect_record || '我的收藏',
        icon: `${require('@/assets/images/person7.png')}`,
        path: '/mycollect'
      },
      {
        id: '6',
        name: this.globalDataArray.siteTemplateLanguage.person_browse_record || '浏览记录',
        icon: `${require('@/assets/images/person8.png')}`,
        path: '/mybrowse'
      },
      {
        id: '8',
        name: this.globalDataArray.siteTemplateLanguage.competition_hosting_history || '办赛记录',
        icon: `${require('@/assets/images/person10.png')}`,
        path: '/competitionhosting'
      }],
      isSelect: '/myrecord',
      curLang: ''
    }
  },
  mounted() {
    this.isSelect = this.$route.path

    const that = this
    const currentLanguge = Cookies.get('DEFAULT_LANG')
    if (currentLanguge != null && currentLanguge != undefined) {
      that.curLang = currentLanguge
    } else {
      that.curLang = that.globalDataArray.siteLanguage[0].value
    }

    this.scrollToCurMenu()
  },
  methods: {
    gopage(path) {
      if (this.isSelect != path) {
        this.$router.push(path)
        this.isSelect = path
        // 跳转后滚动到页面顶部
        this.$nextTick(() => {
          window.scrollTo(0, 0)
        })
      }
    },
    scrollToCurMenu() {
      // 移动端菜单样式是横向滚动，需要定位到当前菜单上
      this.$nextTick(() => {
        const personMenu = this.$refs.personMenu
        // console.log('======> clientHeight:', personMenu.clientHeight)
        if (personMenu.clientHeight > 130) {
          return
        }
        const cur = personMenu.getElementsByClassName('cur')
        // console.log('======> cur:', cur)
        if (cur.length > 0) {
          cur[0].scrollIntoView({ inline: 'center', behavior: 'auto' })
        }
      })
    }
  }
}
</script>
